import { Box, Heading } from '@ksyos/design-system';
import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import type { IServiceStartingPoint } from '@common/interfaces/serviceWorkflow';
import { getSelectedLanguage } from '@frontend/translate';
import { ServiceCard } from './serviceCards/ServiceCard';
import { ServiceCardWithStartButton } from './serviceCards/ServiceCardWithStartButton';
import { StartingPointCard } from './startingPointCards/StartingPointCard';
import { StartingPointCardWithStartButton } from './startingPointCards/StartingPointCardWithStartButton';

type ServiceCardsAndStartingPointsCardsProps = {
    onClickService: (name: any) => void;
    onClickStartingPoint: (startingPoint: IServiceStartingPoint, service: ServiceForSelectedServiceType) => void;
    onClickSubService: (name: any, service: any) => void;
    patientId?: string;
    selectedService?: ServiceForSelectedServiceType;
    selectedStartingPoint?: IServiceStartingPoint;
    services: ServiceForSelectedServiceType[];
};

export function ServiceCardsAndStartingPointsCards(props: ServiceCardsAndStartingPointsCardsProps) {
    const {
        services,
        onClickService,
        onClickSubService,
        onClickStartingPoint,
        selectedStartingPoint,
        patientId,
        selectedService,
    } = props;
    const translate = getSelectedLanguage();

    return (
        <>
            {!patientId && (
                <Heading
                    paddingTop={6}
                    size="medium"
                >
                    Kies het type {getServiceTypeFromServices(services)} dat je wilt starten
                </Heading>
            )}

            <Box
                className="automation-formWizardRow"
                display="grid"
                gap={4}
                gridTemplateColumns="repeat(auto-fill, minmax(320px, 1fr))"
                paddingTop={4}
            >
                {services.map((item, index) => {
                    if (item.startingPoints && item.startingPoints.length > 0) {
                        return item.startingPoints.map((sp) => {
                            if (!patientId) {
                                return (
                                    <StartingPointCard
                                        isSelected={isSelectedStartingPoint(sp, selectedStartingPoint)}
                                        key={sp.label}
                                        onClick={onClickStartingPoint}
                                        service={item}
                                        startingPoint={sp}
                                    />
                                );
                            } else {
                                return (
                                    <StartingPointCardWithStartButton
                                        isSelected={isSelectedStartingPoint(sp, selectedStartingPoint)}
                                        key={sp.label}
                                        onClick={onClickStartingPoint}
                                        service={item}
                                        startingPoint={sp}
                                    />
                                );
                            }
                        });
                    } else {
                        if (!patientId) {
                            return (
                                <ServiceCard
                                    isSelected={isSelectedService(item, selectedService)}
                                    key={item.key + index}
                                    onClick={onClickService}
                                    service={item}
                                />
                            );
                        } else {
                            return (
                                <ServiceCardWithStartButton
                                    isSelected={isSelectedService(item, selectedService)}
                                    key={item.key}
                                    onClickService={onClickService}
                                    onClickSubService={onClickSubService}
                                    service={item}
                                />
                            );
                        }
                    }
                })}
            </Box>
        </>
    );

    function isSelectedService(
        service: ServiceForSelectedServiceType,
        selectedServiceFromProps?: ServiceForSelectedServiceType
    ) {
        return Boolean(selectedServiceFromProps?.key === service.key);
    }

    function isSelectedStartingPoint(sp: IServiceStartingPoint, selectedSp?: IServiceStartingPoint) {
        if (!selectedSp) {
            return false;
        }

        return sp.id === selectedSp.id;
    }

    function getServiceTypeFromServices(servicesData: ServiceForSelectedServiceType[]) {
        if (services) {
            const translationKey = `type_${servicesData[0].serviceType}`;

            return translate.home[translationKey as keyof typeof translate.home].toLowerCase();
        }

        return '';
    }
}
